import { connect, MapStateToProps } from 'react-redux';
import { Props } from './PageContainer';
import { AppState } from '../../types/store';
import { getShouldShowFooter } from '../../selectors/app';

export type StateProps = Pick<Props, 'withFooter'>;
export type OwnProps = Props;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  return {
    withFooter:
      // favor prop if passed then selector
      ownProps.withFooter !== undefined
        ? ownProps.withFooter
        : getShouldShowFooter(state),
  };
};

export default connect(mapStateToProps);
